

































import { Component, Prop, Vue } from 'vue-property-decorator';
import BIObject from '@/types/taxcard/BIObject';
import moment, { Moment } from 'moment';
import i18next from 'i18next';

import NewTranslation from '@/components/i18n/NewTranslation.vue';
import { downloadCodeUrl, formatDownloadCode } from '@/app/utils/formatDownloadCode';

@Component({ components: { NewTranslation } })
export default class TaxcardEntry extends Vue {
  @Prop({})
  taxcard!: any;

  public get isCityTour() {
    return this.taxcard.subGuestType === 'cityTour';
  }

  public get downloadCodeDisplay() {
    return formatDownloadCode(this.taxcard.downloadCode);
  }

  public get downloadCodeHref() {
    return downloadCodeUrl(this.taxcard.downloadCode);
  }

  public get personDate() {
    const taxcard = this.taxcard;
    return moment(taxcard.stayBegin).isSame(moment(taxcard.stayEnd), 'day')
      ? this.formatDate(taxcard.stayBegin)
      : this.formatDate(taxcard.stayBegin) + ' - ' + this.formatDate(taxcard.stayEnd);
  }

  public formatDate(date: string | Moment): string {
    const momentDate = moment(date);
    return momentDate.isValid() ? momentDate.format(i18next.t('common.date.format.short')) : 'Ungültiges Datum';
  }
}
